<template>
  <div id="container">
    <h3>{{trad.pageStart.title}}</h3>
    <a class="btn-preview" href="Demo_LiveConsent_.pdf" target="_blank"
      >{{trad.pageStart.preview}}</a
    >
    <br />
    <button @click="btnChecked">{{trad.pageStart.button}}</button>
    <br />
    <img :src="help[randPic]" alt="Help-pic" />
    <div class="help-container">
      <div class="talk-bubble tri-right round btm-left">
        <div class="talktext">
          <p>{{trad.pageStart.help}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "Welcome",
  data() {
    return {
      checked: false,
      trad: this.langTxt,
      help: ["help0.png", "help1.png", "help2.png", "help3.png", "help4.png"],
    };
  },
  props: ["demoProgression", "randPic","langTxt"],
  methods: {
    btnChecked(e) {
      e.preventDefault();

      this.checked = true;
      this.demoProgression[0].demoStart = this.checked;

      this.$emit("btn-checked", this.demoProgression);
    },
    pdfPreview() {
      let showPdf = document.querySelector(".big-container-pdf");
      showPdf.classList.add("preview-show");
    },
    closePreview() {
      let closePdf = document.querySelector(".big-container-pdf");
      closePdf.classList.remove("preview-show");
    },
  },
};
</script>

<style scoped>
#container {
  padding: 50px;
  box-shadow: 10px 10px 20px 0px rgba(133, 133, 133, 0.55);
  margin: auto;
  width: fit-content;
  margin-top: 15px;
  border-radius: 10px;
  height: 520px;
  position: relative;
}
h3 {
  margin-top: 25px;
  margin-bottom: 30px;
  font-size: 28px;
}
button {
  margin-top: 30px;
  width: 150px;
  height: 40px;
  font-size: 20px;
  border-radius: 10px;
  background-color: #3F608E;
  color: white;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 25px;
  border: none;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
button:hover {
  transition-duration: 0.8s;
  background: #7C9048;
}
.btn-preview {
  margin-bottom: 10px;
  font-size: 20px;
  color: #757575;
  font-weight: bold;
  width: fit-content;
}

/* Start User Help */

.help-container {
  position: absolute;
  width: fit-content;
  height: fit-content;
  bottom: 95px;
  left: 90px;
}
img {
  width: 125px;
  position: absolute;
  left: -5px;
  bottom: -15px;
}
.talk-bubble {
  display: inline-block;
  position: relative;
  width: 300px;
  height: auto;
  background-color: #f9f9db;
}
.border {
  border: 8px solid #666;
}
.round {
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
}
.tri-right.border.btm-left:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -8px;
  right: auto;
  top: auto;
  bottom: -40px;
  border: 32px solid;
  border-color: transparent transparent transparent #666;
}
.tri-right.btm-left:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: 0px;
  right: auto;
  top: auto;
  bottom: -20px;
  border: 22px solid;
  border-color: transparent transparent transparent #f9f9db;
}
.talktext {
  padding: 1em;
  text-align: left;
  line-height: 1.5em;
}
.talktext p {
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
  font-weight: 500;
}

/* End User Help */

@media screen and (max-width: 800px) {
  #container {
    width: 100%;
  }
  .talk-bubble {
    width: 225px;
  }
}

@media screen and (max-width: 375px) and (max-height: 680px) {
  #container {
    width: 100%;
    height: 80vh;
  }
  .error-show {
    top: 38%;
  }
}

@media screen and (max-width: 325px) and (max-height: 600px) {
  #container {
    width: 100%;
    height: 90vh;
  }
  .error-show {
    top: 38%;
  }
}
</style>
